// UX-only soil types for step 1. Not sent to /run-anon (API strips soiltype).

export const ACQUISITION_SOIL_TYPES = ["sandy", "loamy_sand", "sandy_loam", "loam", "silt_loess", "clay_loam", "clay", "peaty", "chalky"] as const;

export type AcquisitionSoilType = (typeof ACQUISITION_SOIL_TYPES)[number];
